/**
 * What a partner still has to do on their Stripe payout account, grouped from
 * the raw `requirements.currently_due` keys (e.g. `external_account`,
 * `representative.dob.day`) into the few steps a partner can recognise. The
 * order is the order they are shown in.
 */
export const PayoutRequirement = {
  BankAccount: 'bank_account',
  BusinessDetails: 'business_details',
  People: 'people',
  Documents: 'documents',
  Terms: 'terms',
  Other: 'other',
};

const PEOPLE_PREFIXES = ['representative.', 'owners.', 'directors.', 'executives.', 'person_', 'relationship.'];

function requirementFor(field) {
  if (field === 'external_account') {
    return PayoutRequirement.BankAccount;
  }

  if (field.includes('verification.document') || field.includes('verification.additional_document')) {
    return PayoutRequirement.Documents;
  }

  if (field.startsWith('tos_acceptance.')) {
    return PayoutRequirement.Terms;
  }

  if (PEOPLE_PREFIXES.some((prefix) => field.startsWith(prefix)) || field.endsWith('_provided')) {
    return PayoutRequirement.People;
  }

  if (field.startsWith('company.') || field.startsWith('business_profile.') || field === 'business_type') {
    return PayoutRequirement.BusinessDetails;
  }

  return PayoutRequirement.Other;
}

export function describePayoutRequirements(currentlyDue) {
  const found = new Set((currentlyDue ?? []).map(requirementFor));

  return Object.values(PayoutRequirement).filter((requirement) => found.has(requirement));
}
